var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownToLineSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D9CD3;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,480c-17.7,0-32-14.3-32-32s14.3-32,32-32h320c17.7,0,32,14.3,32,32s-14.3,32-32,32H32z M214.6,342.6 c-12.5,12.5-32.8,12.5-45.3,0l-128-128c-12.5-12.5-12.5-32.8,0-45.3s32.8-12.5,45.3,0l73.4,73.4V64c0-17.7,14.3-32,32-32 s32,14.3,32,32v178.7l73.4-73.4c12.5-12.5,32.8-12.5,45.3,0s12.5,32.8,0,45.3L214.6,342.6L214.6,342.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownToLineSolid);
export default __webpack_public_path__ + "static/media/arrow-down-to-line-solid.c49af9868fe5e113265f55ee49dc08fc.svg";
export { ForwardRef as ReactComponent };